import React, { useState, useContext, useEffect } from "react";
import "./LoginPage.css";
import { Link, useNavigate } from "react-router-dom";

import Cookies from "js-cookie";
import { Context } from "../../../../utils/context";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { Roles } from "../../../../utils/common";
import { getData } from "../../../../utils/api";
import axiosClient from "../../../../utils/ApiInstance";
import CheckExist from "../../../common/modal/checkexist/CheckExist";
const LoginPage = () => {
  const { postData, signin, setSignin, usertype, setUsertype } =
    useContext(Context);

  const navigate = useNavigate();

  const [showForgetPassword, setShowForgetPassword] = useState(false);

  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const [errors, setErrors] = useState({});
  const [showErrorModal, setShowErrorModal] = useState();
  const [Hide, setHide] = useState(false);

  const validateForm = () => {
    let errors = {};

    const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

    if (!formData.email.trim()) {
      errors.email = "Email is required";
    } else if (!emailRegex.test(formData.email)) {
      errors.email = "Enter a valid email address";
    }

    if (!formData.password.trim()) {
      errors.password = "Password is required";
    } else if (formData.password.trim().length < 6) {
      errors.password = "Password must be at least 6 characters";
    }

    return errors;
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validateForm();

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
    } else {
      try {
        const response = await postData("/login", formData);

        console.log(response, "response");

        if (response.success) {
          setSignin(response.success);
          setUsertype(response?.data?.role);

          Cookies.set("it_pulse_security", response.data?.token, {
            expires: 2,
          });

          console.log(response?.data?.role, "response?.data?.role");

          switch (response?.data?.role) {
            case Roles.SuperAdmin:
              navigate("/super-admin/dashboard");
              break;

            case Roles.Admin:
              navigate("/advanceDashboard");
              break;

            case Roles.TeleCaller:
            case Roles.SalesManager:
            case Roles.SalesCoOrdinater:
            case Roles.SalesExecutive:
              navigate("/lead-dashboard");
              break;

            case Roles.Complaint:
              navigate("/complaint-manage");
              break;

            case Roles.HRMS:
              navigate("/hrms-admin/hrms-dashboard");
              break;

            case Roles.ProjectManager:
              navigate("/projectDashboard");
              break;

            default:
              navigate("/login");
              break;
          }

       
        } else {
          setShowErrorModal(response);
        }
      } catch (error) {
        console.error("Error submitting form:", error);
      }
    }
  };

  const errorStyle = {
    color: "red",
    marginLeft: "5px",
  };

  const successStyle = {
    color: "green",
    marginLeft: "5px",
  };

  const DefaultAPICall = async () => {
    // const response = await axiosClient.get("http://192.168.16.56:1621/");

    const response = await axiosClient.get("https://node.itpulse.in:1621/");

    // const response = await axiosClient.get(
    //   "https://itpulsenode.profcymadev.com:1621/",
    // );
  };

  useEffect(() => {
    DefaultAPICall();
  }, []);

  return (
    <>
      <section className="Login">
        <div className="container-fluid p-0">
          <div className="card text-center login-card p-5">
            <div className="text-holder-login">
              <h2>Login Here</h2>

              {showErrorModal?.success ? (
                <></>
              ) : (
                <>
                  <span style={errorStyle}>{showErrorModal?.message}</span>
                </>
              )}
              <form onSubmit={handleSubmit} role="form">
                <div className="mb-3 loginForm_txt_main">
                  <label
                    for="exampleFormControlInput1"
                    class="form-label loginForm_txt">
                    Email
                  </label>
                  <input
                    type="email"
                    className="form-control form-control-email"
                    id="exampleInputEmail1"
                    aria-describedby="emailHelp"
                    placeholder="Enter Email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                  />
                  {errors.email && (
                    <span style={errorStyle}>{errors.email}</span>
                  )}
                </div>
                <div className="loginForm_txt_main">
                  <label
                    for="exampleFormControlInput1"
                    class="form-label loginForm_txt">
                    Password
                  </label>
                  <input
                    minLength={6}
                    type={Hide ? "text" : "password"}
                    className="form-control form-control-email"
                    placeholder="Password"
                    aria-label="Recipient's username"
                    aria-describedby="basic-addon2"
                    name="password"
                    value={formData.password}
                    onChange={handleChange}
                  />
                  <FontAwesomeIcon
                    icon={Hide ? faEye : faEyeSlash}
                    className="login_eye_icon"
                    onClick={() => setHide(!Hide)}
                  />

                  {/* <button
                    type="button"
                    className="input-group-text hide-name"
                    id="basic-addon2"
                    onClick={() => {
                      setHide(!Hide);
                    }}
                  >
                    {Hide ? "Hide" : "Show"}
                  </button> */}
                </div>
                {errors.password && (
                  <span style={errorStyle}>{errors.password}</span>
                )}
                <div className="text-end forget_text_holder">
                  <span
                    className="forgot-password"
                    onClick={() => setShowForgetPassword(true)}>
                    Forgot password?
                  </span>
                </div>

                <button type="submit" className="btn sign-in-button">
                  Login
                </button>
              </form>

              <CheckExist
                show={showForgetPassword}
                onHide={() => {
                  setShowForgetPassword(false);
                }}
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default LoginPage;
